/* eslint-disable import/prefer-default-export */
export const getJobLineKey = (survey) => {
	return `${survey?.customer}~${survey?.jobNumber}~${survey?.lineName}`;
}
